import React from 'react';
import { Pressable, Text, StyleSheet, ViewStyle, TextStyle } from 'react-native';
import { useTheme } from '../../contexts/ThemeContext';
import { createStyles } from '../../shared/utils/styles';
import { DesignTokens } from '../../shared/types/tokens';
import { addColorOpacity } from '../../shared/utils/styles';

export interface TabButtonProps {
  title: string;
  onPress: () => void;
  active?: boolean;
  disabled?: boolean;
  style?: ViewStyle;
  textStyle?: TextStyle;
}

export function TabButton({
  title,
  onPress,
  active = false,
  disabled = false,
  style,
  textStyle,
}: TabButtonProps) {
  const { tokens } = useTheme();
  const utils = createStyles(tokens);
  const styles = makeStyles(tokens, utils);

  const activeStyle = active ? styles.active : styles.inactive;
  const activeTextStyle = active ? styles.activeText : styles.inactiveText;
  const disabledStyle = disabled ? styles.disabled : null;

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      style={({ pressed }) => [
        styles.base,
        activeStyle,
        disabledStyle,
        pressed && !disabled && styles.pressed,
        style,
      ]}
    >
      <Text style={[activeTextStyle, textStyle]}>
        {title}
      </Text>
    </Pressable>
  );
}

function makeStyles(tokens: DesignTokens, utils: ReturnType<typeof createStyles>) {
  return StyleSheet.create({
    base: {
      paddingHorizontal: utils.spacing.lg,
      paddingVertical: utils.spacing.md,
      borderRadius: utils.radius.md,
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 44,
      minWidth: 80,
    },
    active: {
      backgroundColor: tokens.color.primary,
    },
    activeText: {
      color: tokens.color.onPrimary,
      fontSize: utils.typography.sizes.base,
      fontWeight: utils.typography.weights.semibold,
      fontFamily: utils.typography.body.fontFamily,
    },
    inactive: {
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderColor: tokens.color.border,
    },
    inactiveText: {
      color: tokens.color.onSurface,
      fontSize: utils.typography.sizes.base,
      fontWeight: utils.typography.weights.medium,
      fontFamily: utils.typography.body.fontFamily,
    },
    disabled: {
      opacity: 0.6,
    },
    pressed: {
      opacity: 0.8,
    },
  });
}

